import { motion, useReducedMotion } from 'motion/react';

export default function ToolsPageTransition({ children, direction = 'right' }) {
  const reduceMotion = useReducedMotion();

  return <motion.div
    initial={reduceMotion ? false : { opacity: 0, x: direction === 'left' ? -8 : 8 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: reduceMotion ? 0 : 0.22, ease: 'easeOut' }}>
    {children}
  </motion.div>;
}
